var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.6193L18.067 10.98L19.7802 12.6932L10.1802 17.5987L10.1739 12.2607H10.1444L0 17.2738V19.4723L8.20114 15.415L8.20747 20.8142L10.1781 19.8078L20.5778 14.4929L21.0293 16.9425L23.9979 11.6151L24 11.6193Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34552 13.0029L2.61523 14.9208V10.6567L6.34552 9.16504V13.0029Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.035 10.6593L7.30469 12.5772V6.18212L11.035 4.69043V10.6593Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8319 13.6447L12.1016 15.5625V1.49169L15.8319 0V13.6425V13.6447Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.930179b296ad74b179c56a8210288e87.svg";
export { ForwardRef as ReactComponent };